import { FC, useState } from "react";
import { Box } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import SettingTitle from "../component/SettingTitle";
import MenuItemCard from "../component/MenuItemCard";
import WalletBanknoteSvg from "@/assets/svg/WalletBanknoteSvg";
import ForgotPassword from "@/components/UI/modal/Wallet/ForgotPassword";
import { books } from "@/assets/books";

const WalletSettings: FC = () => {
  const location = useLocation();
  const [forgotOpen, setForgotOpen] = useState(false);

  const isRoot = location.pathname === "/settings/wallet";

  const menuItems = [
    {
      title: "Withdrawal Addresses",
      subtitle: "Manage your connected wallets to withdraw funds earned on the platform.",
      icon: <WalletBanknoteSvg width={24} height={24} />,
      link: books.withdrawalAddresses,
    },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
      {forgotOpen && <ForgotPassword onClose={() => setForgotOpen(false)} />}

      {isRoot ? (
        <Box>
          <SettingTitle title="Wallet" isActive />
          <Box bgcolor="white">
            {menuItems.map((item, index) => (
              <MenuItemCard key={index} item={item} />
            ))}
          </Box>
        </Box>
      ) : (
        <Box sx={{ maxWidth: "544px" }}>
          <Outlet />
        </Box>
      )}
    </Box>
  );
};

export default WalletSettings;
